<template>
	<a-result status="403" title="403" sub-title="对不起，您没有访问此页面的权限。"> </a-result>
</template>
<script name="Page403"></script>
